const extractAddressComponents = (components = []) => {
  const address = {};

  components.forEach((part) => {
    const types = part?.types || [];

    if (types.includes('route') || types.includes('street_address')) {
      address.streetAddress = part?.long_name;
    }

    if (types.includes('street_number')) {
      address.streetNumber = part?.long_name;
    }

    if (
      types.includes('locality') ||
      types.includes('sublocality') ||
      types.includes('sublocality_level_1') ||
      types.includes('sublocality_level_2') ||
      types.includes('sublocality_level_3') ||
      types.includes('sublocality_level_4')
    ) {
      address.locality = part?.long_name;
    }

    if (
      types.includes('administrative_area_level_1') ||
      types.includes('administrative_area_level_2') ||
      types.includes('administrative_area_level_3') ||
      types.includes('administrative_area_level_4') ||
      types.includes('administrative_area_level_5')
    ) {
      address.region = part?.long_name;
    }

    if (types.includes('country')) {
      address.country = part?.long_name;
    }

    if (types.includes('postal_code')) {
      address.postalCode = part?.long_name;
    }
  });

  return address;
};

export default extractAddressComponents;
